import { success, error } from 'redux-saga-requests';
import {
  GET_EXPENSES_TYPES,
  CREATE_EXPENSES_TYPE,
  REMOVE_EXPENSES_TYPE,
  UPDATE_EXPENSES_TYPE,
} from './types';

const initialState = {
  expensesTypes: [],
  loading: false,
  error: null,
};

const getExpenseTypeId = (expenseType) => expenseType?.id ?? expenseType?.expense_type_id;
const getExpenseTypesList = (data) => data?.expense_types ?? data?.expenses_types ?? data ?? [];
const getExpenseTypePayload = (data) => data?.expense_type ?? data;
const idsMatch = (left, right) => String(left) === String(right);

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_EXPENSES_TYPES:
    case CREATE_EXPENSES_TYPE:
    case REMOVE_EXPENSES_TYPE:
    case UPDATE_EXPENSES_TYPE:
      return { ...state, error: null, loading: true };

    case success(GET_EXPENSES_TYPES):
      return {
        ...state,
        expensesTypes: getExpenseTypesList(action.data),
        loading: false,
      };

    case success(CREATE_EXPENSES_TYPE):
      return {
        ...state,
        expensesTypes: [...state.expensesTypes, getExpenseTypePayload(action.data)],
        loading: false,
      };

    case success(REMOVE_EXPENSES_TYPE):
      {
        const requestExpenseTypeId = action?.meta?.requestAction?.expenseTypeId;

      return {
        ...state,
        expensesTypes: state.expensesTypes.filter((expenseType) => !idsMatch(getExpenseTypeId(expenseType), requestExpenseTypeId)),
        loading: false,
      };
      }

    case success(UPDATE_EXPENSES_TYPE):
      {
        const payloadExpenseType = getExpenseTypePayload(action.data);
        const requestExpenseTypeId = action?.meta?.requestAction?.expenseTypeId ?? getExpenseTypeId(payloadExpenseType);

      return {
        ...state,
        expensesTypes: state.expensesTypes.map((expenseType) => (
          idsMatch(getExpenseTypeId(expenseType), requestExpenseTypeId)
            ? { ...expenseType, ...payloadExpenseType }
            : expenseType
        )),
        loading: false,
      };
      }

    case error(GET_EXPENSES_TYPES):
    case error(CREATE_EXPENSES_TYPE):
    case error(REMOVE_EXPENSES_TYPE):
    case error(UPDATE_EXPENSES_TYPE):
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export default reducer;
